import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const PaymentMethodsForm = () => {
  const [type, setType] = useState("");

  const handleChange = (event) => {
    setType(event.target.value);
  };
  return (
    <Stack direction='column' spacing={2}>
      <Box component={Paper} elevation={0}>
        <Box px={3} py={2}>
          <Typography variant='h4'>Title Translation</Typography>
        </Box>
        <Divider />
        <Box px={3} py={2}>
          <TextField fullWidth label='Title English' id='title_english' />
        </Box>
      </Box>

      <TextField fullWidth label='Slug' id='slug'></TextField>
      <TextField
        fullWidth
        multiline
        rows={5}
        label='Meta'
        id='meta'
      ></TextField>

      <FormGroup>
        <FormControlLabel
          control={<Checkbox color='default' />}
          label='Enabled ?'
        />
      </FormGroup>

      <FormControl fullWidth>
        <InputLabel id='select-type'>Type</InputLabel>
        <Select
          labelId='select-type'
          id='simple-select'
          value={type}
          label='Type'
          onChange={handleChange}
        >
          <MenuItem value={1}>Postpaid</MenuItem>
          <MenuItem value={2}>Prepaid</MenuItem>
        </Select>
      </FormControl>

      <Stack direction='row' spacing={2}>
        <Button variant='contained' sx={{ padding: 1 }} disabled>
          SAVE
        </Button>
        <Button variant='contained' sx={{ padding: 1 }} color='error'>
          CANCEL
        </Button>
      </Stack>
    </Stack>
  );
};

export default PaymentMethodsForm;
